<div id="navbar" class="navbar-collapse collapse">
  <ul class="nav navbar-nav">
    <li
      class="dropdown"
      *ngIf="
        model.isSystemManagementMenuAvailable ||
        model.isFacilitiesOrAgenciesMenuAvailable ||
        model.isUploaderToolMenuAvailable
      "
    >
      <a
        href="#"
        name="menuSystemManagement"
        class="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
        >System Management <span class="caret"></span
      ></a>
      <ul class="dropdown-menu" role="menu">
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementPlans"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'plans']"
            >Plans</a
          >
        </li>
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementPayers"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'payers']"
            >Payers</a
          >
        </li>
        <li>
          <a
            *ngIf="
              model.isSystemManagementMenuAvailable || model.isFacilitiesOrAgenciesMenuAvailable
            "
            name="systemManagementFoa"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'providers']"
            >Facilities<span *ngIf="model.isSystemManagementMenuAvailable"> or Agencies</span></a
          >
        </li>
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementFeeSchedules"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'feeschedules']"
            >Fee Schedules</a
          >
        </li>
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementEntityGroups"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'entitygroups']"
            >Entity Groups</a
          >
        </li>
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementBundleDefinitions"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'bundledefinitions']"
            >Bundle Definitions</a
          >
        </li>
        <li>
          <a
            *ngIf="model.isSystemManagementMenuAvailable"
            name="systemManagementMarkets"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'markets']"
            >Markets</a
          >
        </li>
        <li *ngIf="model.isUploaderToolMenuAvailable">
          <a
            name="systemManagementUploaders"
            [routerLinkActive]="['active']"
            [routerLink]="['/system', 'uploaders']"
            >Uploader tools</a
          >
        </li>
      </ul>
    </li>
    <li class="dropdown" *ngIf="model.isTransactionManagementMenuAvailable">
      <a
        href="#"
        name="menuExchange"
        class="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
        >Exchange <span class="caret"></span
      ></a>
      <ul class="dropdown-menu" role="menu">
        <li>
          <a
            name="exchangeClaimInventory"
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions', 'claims-list']"
            >Claim Inventory</a
          >
        </li>
        <li>
          <a
            name="exchangeRemittanceInventory"
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions', 'remit-list']"
            >Remittance Inventory</a
          >
        </li>
        <li>
          <a
            name="exchangePaymentInventory"
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions', 'payments']"
            >Payment Inventory</a
          >
        </li>
      </ul>
    </li>
    <li class="dropdown" *ngIf="model.isPatientManagmentMenuAvailable">
      <a
        [href]="trackerUrl"
        name="menuTracker"
        class="dropdown-toggle"
        role="button"
        aria-expanded="false"
        >Tracker</a
      >
    </li>
    <li class="dropdown" *ngIf="model.isAdministrationMenuAvailable">
      <a
        href="#"
        name="menuAdministration"
        class="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
        >Administration <span class="caret"></span
      ></a>
      <ul class="dropdown-menu" role="menu">
        <li *ngIf="model.isUserManagementMenuAvailable">
          <a
            name="administrationUsers"
            [routerLinkActive]="['active']"
            [routerLink]="['/admin', 'users']"
            >Users</a
          >
        </li>
        <li *ngIf="model.isAllUserManagementMenuAvailable">
          <a
            name="administrationPermissions"
            [routerLinkActive]="['active']"
            [routerLink]="['/admin', 'permissions']"
            >Permissions</a
          >
        </li>
      </ul>
    </li>
  </ul>
  <ul class="nav navbar-nav navbar-right" *ngIf="model.isAuthenticated">
    <li>
      <a>{{ model.username }}</a>
    </li>
    <li>
      <a name="userSignOut" class="btn-icon" (click)="signOut()">
        <i
          class="fa fa-sign-out"
          title="Sign Out"
          data-placement="bottom"
          data-toggle="tooltip"
        ></i>
      </a>
    </li>
  </ul>
  <ul class="nav navbar-nav navbar-right" *ngIf="!model.isAuthenticated">
    <li>
      <a name="userSignIn" class="btn-icon" (click)="signIn()">
        <i class="fa fa-sign-in" title="Sign In" data-placement="bottom" data-toggle="tooltip"></i>
      </a>
    </li>
  </ul>
</div>
